import { createBrowserHistory, createHashHistory } from "history";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

import { appInsightsKey } from "./helpers/keys";

var appInsights = new ApplicationInsights({
  config: {
    // eslint-disable-next-line
    instrumentationKey: appInsightsKey(),
  },
});

appInsights.loadAppInsights();

export default createBrowserHistory();
const hashHistory = createHashHistory();

hashHistory.listen((location) => {
  var path =
    "/" +
    location.pathname
      .split("/")
      .filter((e) => !!e && isNaN(e))
      .join("/");
  appInsights.trackPageView({ name: path, url: location.pathname });

  if( window.gtag){
    window.gtag('config', 'G-HX41K674N5', 
    { page_path: path })
  }

});

export { hashHistory };



// WEBPACK FOOTER //
// ./src/browserHistory.js